export const setDimension = (dimension) =>{
  //console.log('Action: setDimension')
  return {
    type: 'setDimension',
    payload: dimension
  }
}
